import React from 'react';

const ArrowLeft = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M13.7139 6.02515L8.25904 11.48C7.92431 11.8147 7.92431 12.3574 8.25904 12.6922L13.7139 18.147"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default ArrowLeft;
